import { render, staticRenderFns } from "./BeneficiaryDetails.vue?vue&type=template&id=eea2c22c&scoped=true"
import script from "./BeneficiaryDetails.vue?vue&type=script&lang=js"
export * from "./BeneficiaryDetails.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=eea2c22c&prod&scoped=true&lang=css&external"
import style1 from "./BeneficiaryDetails.vue?vue&type=style&index=1&id=eea2c22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea2c22c",
  null
  
)

export default component.exports